export default __webpack_public_path__ + "1acf5ddd2e3af568904501ce31ffb74c.png";